import styles from './styles.module.scss';

import { FormSignatories } from './FormSignatories';
import { FormRecipients } from './FormRecipients';
import { FormEditors } from './FormEditors';
import { ReplaceEntityModal } from '../../ReplaceEntityModal';
import { AgentsType, ClientsType } from 'types';
import { useState } from 'react';
import { getFormMetaSelector } from 'store/selectors/requestFormProcess';
import { useSelector } from 'react-redux';
import { FormsTableStatus } from 'app-constants';

export const TrackingTab = (props) => {
  const [replaceEntityModal, setReplaceEntityModal] = useState<{
    open: boolean;
    isEditor?: boolean;
    entityId?: number;
    name?: string;
    email?: string;
    role?: string;
    options?: ClientsType & AgentsType;
  }>({ open: false });

  const { formDetails, handleReplaceEntity, selectedFormStatus } = props;
  const { clients, agents } = useSelector(getFormMetaSelector);

  const closeReplaceEntityModal = () => {
    setReplaceEntityModal({ open: false });
  };

  if (!formDetails) return null;

  const isWaitingOnYouForm = selectedFormStatus === FormsTableStatus.WaitingOnYou;

  const editorProps = {
    ...props,
    setReplaceEntityModal,
    clients,
    agents,
    isWaitingOnYouForm,
  };

  return (
    <div className={styles.trackingTab}>
      <FormEditors {...editorProps} />

      <FormSignatories {...editorProps} />

      <FormRecipients {...props} />

      <ReplaceEntityModal
        url={formDetails.formDocument?.url}
        replaceEntityData={replaceEntityModal}
        onCloseModal={closeReplaceEntityModal}
        handleReplaceEntity={handleReplaceEntity}
      />
    </div>
  );
};
